import { Component, inject, OnDestroy, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { UiModule } from '@components/ui/ui-module';
import { Card } from '@models/card.model';
import { Card as CardService } from '@services/card.service';
import { Router } from '@services/route.service';

@Component({
  selector: 'lgb-card-list',
  imports: [
    UiModule,
    FormsModule,
    RouterModule
  ],
  templateUrl: './card-list.html',
  styleUrl: './card-list.css',
})
export class CardList {
  readonly router=inject(Router);
  readonly cardsS=inject(CardService);
  readonly cards=signal<Card[]>([]);
  readonly qSearch=signal<string>(null);

  readonly loading=signal<boolean>(false);

  getSearchObs(){
    return (q: string, start: number, length: number) => {
      if(q!=null && q.trim()!="")
        return this.cardsS.searchCards(q, start, length);
      else
        return this.cardsS.getCards(start, length);
    };
  }

  getImages(img: string){
    return this.cardsS.getImages(img);
  }
}
